import type {
  MediaAttachmentDto,
  MediaAttachmentFileDto,
  MediaFolderListItemContractDto,
  MediaOwnerAttachmentsReplaceRequest,
  MediaRenditionDto,
} from '../../api/contracts';
import type { RenditionViewModel } from './media-attachments-owner.view-model';

export type SystemMediaRole = MediaAttachmentDto['role'];
export type MediaRole = SystemMediaRole | (string & {});
export type MediaRoleCode = MediaRole;
export type MediaOwnerType = MediaOwnerAttachmentsReplaceRequest['ownerType'];
export type MediaFileStatus = MediaAttachmentFileDto['status'];
export type MediaFileType = MediaAttachmentFileDto['type'];
export type RenditionKind = MediaRenditionDto['kind'];
export type PublicDeliveryStatus = NonNullable<MediaAttachmentDto['publicDeliveryStatus']>;
export type MediaFolderSystemKey = NonNullable<MediaFolderListItemContractDto['systemKey']>;

export interface MediaFolderListItemViewModel {
  id: number;
  parentId: number | null;
  investmentId: number | null;
  name: string;
  sortOrder: number;
  system: boolean;
  systemKey: MediaFolderSystemKey | null;
  locked: boolean;
  childrenCount: number;
  filesCount: number;
}

export interface MediaFolderChildrenViewModel {
  parentFolderId: number;
  items: MediaFolderListItemViewModel[];
}

export interface FolderPathViewModel {
  folderId: number;
  path: { id: number; name: string }[];
}

export interface MediaFileListItemViewModel {
  id: number;
  folderId: number;
  type: MediaFileType;
  status: MediaFileStatus;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  widthPx: number | null;
  heightPx: number | null;
  isRendition: boolean;
  createdDate: string;
  etag: string | null;
  previewUrl: string | null;
  thumbnail: RenditionViewModel | null;
}

export interface MediaFileDetailsViewModel {
  id: number;
  type: MediaFileType;
  status: MediaFileStatus;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  widthPx: number | null;
  heightPx: number | null;
  sha256Hex: string | null;
  etag: string | null;
  previewUrl: string | null;
  downloadUrl: string | null;
  renditions: RenditionViewModel[];
  publicDeliveryStatus?: PublicDeliveryStatus;
}

export interface MediaFilePageViewModel {
  content: MediaFileListItemViewModel[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

export interface FolderTreeNode {
  key: string;
  label: string;
  data: MediaFolderListItemViewModel;
  leaf: boolean;
  loading?: boolean;
  children?: FolderTreeNode[];
  icon?: string;
}
